export default __webpack_public_path__ + "static/media/MySQL.0e065a14.png";